import useSWR from 'swr';
import { FetchResult, Ticket } from '../entities';

type Result = FetchResult & { tickets: Ticket[] };

export function useTickets(): Result {
  const { data, error, mutate } = useSWR(`/tickets`);

  return {
    tickets: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
